import {
  addUploadToProject,
  alwaysCreateNewProject,
} from 'src/modules/homeownerApp/components/UploadImage';
import { Web } from 'src/shared/constants/FeatureFlag';
import {
  TranslationNamespace,
  useTranslate,
  useTreatment,
} from 'src/shared/hooks';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

export const useCtaText = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const isNewProjectUiEnabled = isEnabled(useTreatment(Web.NEW_PROJECT_UI));
  const project = addUploadToProject();

  if (!isNewProjectUiEnabled) {
    return t('uploadImage.createDesigns');
  }

  return project && !alwaysCreateNewProject()
    ? t('uploadImage.next')
    : t('uploadImage.createProject');
};
